export interface EntradaSpeedDial {
  semHover: boolean;
  temAcoesSecundarias: boolean;
  temAcaoPrimaria: boolean;
}

export interface ComportamentoSpeedDial {
  fabAbreMenu: boolean;
  acaoPrimariaNaLista: boolean;
}

export const comportamentoSpeedDial = ({
  semHover,
  temAcoesSecundarias,
  temAcaoPrimaria
}: EntradaSpeedDial): ComportamentoSpeedDial => {
  const fabAbreMenu = semHover && temAcoesSecundarias;
  return { fabAbreMenu, acaoPrimariaNaLista: fabAbreMenu && temAcaoPrimaria };
};

export interface EntradaRotulo {
  editando: boolean;
  temAcaoPrimaria: boolean;
  fabAbreMenu: boolean;
}

export const rotuloDoBotaoFlutuante = ({ editando, temAcaoPrimaria, fabAbreMenu }: EntradaRotulo) => {
  if (!temAcaoPrimaria || fabAbreMenu) {
    return "Ações";
  }
  return editando ? "Editar" : "Adicionar";
};

export default comportamentoSpeedDial;
